/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./graphql";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    cognitoID
    email
    organizationGroup
    firstName
    lastName
    username
    avatarUrl
    bannerImageUrl
    bio
    jobTitle
    type
    lookingForType
    isClosedForAcceptingMentee
    joinedAt
    lastLoginAt
    deletedAt
    deletedBy
    phone
    points
    lifetimePoints
    dateOfBirth
    isOnboarded
    disabledQuickQuestion
    finishedUserGuideContext
    focusedSkillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    minimumIntroducers
    givenRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    receivedRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    averageRating
    avgMentorRating
    avgMenteeRating
    avgAllyRating
    userHomepageConfig
    socialMedia {
      linkedIn
      __typename
    }
    targetGoals {
      circle
      event
      connection
      __typename
    }
    interest
    expertises
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    awards
    titleRank
    sensitiveQuestionConsent
    isAskedTwiceAlready
    skippedSensitiveQuestion {
      dateOfBirth
      sexuality
      religion
      class
      relationshipStatus
      category
      taxBracket
      nativeBorn
      birthCity
      moonSign
      sunSign
      generation
      favePoliticalParty
      __typename
    }
    ethnicity
    sexuality
    extrovertOrIntrovert
    sensingOrIntuition
    thinkingOrFeeling
    judgingOrPerceiving
    personalityType
    religion
    class
    relationshipStatus
    childhoodZip
    dogOwner
    catOwner
    moonSign
    sunSign
    morningVsNightPerson
    hasSiblings
    birthOrder
    heroes
    sages
    celebsLoveToMeet
    personalityTest
    eatOutVsEatIn
    almaMater
    gender
    race
    vegan
    taxBracket
    nativeBorn
    currentZip
    artist
    musicalInstrument
    generation
    companyClub
    favorites {
      faveMusicGenre
      faveSinger
      faveMuseum
      faveSportTeam
      faveSport
      faveLanguage
      faveTVShow
      faveBoardGame
      faveVideoGame
      faveBook
      faveTheatreShow
      faveVacation
      faveNewsSource
      faveCity
      faveRestaurant
      faveBar
      faveNightClub
      favePoliticalParty
      faveCharities
      faveDrink
      __typename
    }
    workBehaviours {
      collaboration
      motivation
      pressure
      workLifeBalance
      communication
      openOfficeEnvirontment
      contributorOrManager
      __typename
    }
    totalSiblings
    vegetarian
    birthCountry
    birthCity
    introVsExtro
    selectedFavorites
    zipCode
    collegeMajor
    isFirstGenerationCollege
    highSchool
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userFocusedSkillTrackId
    userDepartmentId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    cognitoID
    email
    organizationGroup
    firstName
    lastName
    username
    avatarUrl
    bannerImageUrl
    bio
    jobTitle
    type
    lookingForType
    isClosedForAcceptingMentee
    joinedAt
    lastLoginAt
    deletedAt
    deletedBy
    phone
    points
    lifetimePoints
    dateOfBirth
    isOnboarded
    disabledQuickQuestion
    finishedUserGuideContext
    focusedSkillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    minimumIntroducers
    givenRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    receivedRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    averageRating
    avgMentorRating
    avgMenteeRating
    avgAllyRating
    userHomepageConfig
    socialMedia {
      linkedIn
      __typename
    }
    targetGoals {
      circle
      event
      connection
      __typename
    }
    interest
    expertises
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    awards
    titleRank
    sensitiveQuestionConsent
    isAskedTwiceAlready
    skippedSensitiveQuestion {
      dateOfBirth
      sexuality
      religion
      class
      relationshipStatus
      category
      taxBracket
      nativeBorn
      birthCity
      moonSign
      sunSign
      generation
      favePoliticalParty
      __typename
    }
    ethnicity
    sexuality
    extrovertOrIntrovert
    sensingOrIntuition
    thinkingOrFeeling
    judgingOrPerceiving
    personalityType
    religion
    class
    relationshipStatus
    childhoodZip
    dogOwner
    catOwner
    moonSign
    sunSign
    morningVsNightPerson
    hasSiblings
    birthOrder
    heroes
    sages
    celebsLoveToMeet
    personalityTest
    eatOutVsEatIn
    almaMater
    gender
    race
    vegan
    taxBracket
    nativeBorn
    currentZip
    artist
    musicalInstrument
    generation
    companyClub
    favorites {
      faveMusicGenre
      faveSinger
      faveMuseum
      faveSportTeam
      faveSport
      faveLanguage
      faveTVShow
      faveBoardGame
      faveVideoGame
      faveBook
      faveTheatreShow
      faveVacation
      faveNewsSource
      faveCity
      faveRestaurant
      faveBar
      faveNightClub
      favePoliticalParty
      faveCharities
      faveDrink
      __typename
    }
    workBehaviours {
      collaboration
      motivation
      pressure
      workLifeBalance
      communication
      openOfficeEnvirontment
      contributorOrManager
      __typename
    }
    totalSiblings
    vegetarian
    birthCountry
    birthCity
    introVsExtro
    selectedFavorites
    zipCode
    collegeMajor
    isFirstGenerationCollege
    highSchool
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userFocusedSkillTrackId
    userDepartmentId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    cognitoID
    email
    organizationGroup
    firstName
    lastName
    username
    avatarUrl
    bannerImageUrl
    bio
    jobTitle
    type
    lookingForType
    isClosedForAcceptingMentee
    joinedAt
    lastLoginAt
    deletedAt
    deletedBy
    phone
    points
    lifetimePoints
    dateOfBirth
    isOnboarded
    disabledQuickQuestion
    finishedUserGuideContext
    focusedSkillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    minimumIntroducers
    givenRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    receivedRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    averageRating
    avgMentorRating
    avgMenteeRating
    avgAllyRating
    userHomepageConfig
    socialMedia {
      linkedIn
      __typename
    }
    targetGoals {
      circle
      event
      connection
      __typename
    }
    interest
    expertises
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    awards
    titleRank
    sensitiveQuestionConsent
    isAskedTwiceAlready
    skippedSensitiveQuestion {
      dateOfBirth
      sexuality
      religion
      class
      relationshipStatus
      category
      taxBracket
      nativeBorn
      birthCity
      moonSign
      sunSign
      generation
      favePoliticalParty
      __typename
    }
    ethnicity
    sexuality
    extrovertOrIntrovert
    sensingOrIntuition
    thinkingOrFeeling
    judgingOrPerceiving
    personalityType
    religion
    class
    relationshipStatus
    childhoodZip
    dogOwner
    catOwner
    moonSign
    sunSign
    morningVsNightPerson
    hasSiblings
    birthOrder
    heroes
    sages
    celebsLoveToMeet
    personalityTest
    eatOutVsEatIn
    almaMater
    gender
    race
    vegan
    taxBracket
    nativeBorn
    currentZip
    artist
    musicalInstrument
    generation
    companyClub
    favorites {
      faveMusicGenre
      faveSinger
      faveMuseum
      faveSportTeam
      faveSport
      faveLanguage
      faveTVShow
      faveBoardGame
      faveVideoGame
      faveBook
      faveTheatreShow
      faveVacation
      faveNewsSource
      faveCity
      faveRestaurant
      faveBar
      faveNightClub
      favePoliticalParty
      faveCharities
      faveDrink
      __typename
    }
    workBehaviours {
      collaboration
      motivation
      pressure
      workLifeBalance
      communication
      openOfficeEnvirontment
      contributorOrManager
      __typename
    }
    totalSiblings
    vegetarian
    birthCountry
    birthCity
    introVsExtro
    selectedFavorites
    zipCode
    collegeMajor
    isFirstGenerationCollege
    highSchool
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userFocusedSkillTrackId
    userDepartmentId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createUserExternalNotificationSettings = /* GraphQL */ `mutation CreateUserExternalNotificationSettings(
  $input: CreateUserExternalNotificationSettingsInput!
  $condition: ModelUserExternalNotificationSettingsConditionInput
) {
  createUserExternalNotificationSettings(input: $input, condition: $condition) {
    id
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    extNotificationChannel
    extUserID
    isEnabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserExternalNotificationSettingsMutationVariables,
  APITypes.CreateUserExternalNotificationSettingsMutation
>;
export const updateUserExternalNotificationSettings = /* GraphQL */ `mutation UpdateUserExternalNotificationSettings(
  $input: UpdateUserExternalNotificationSettingsInput!
  $condition: ModelUserExternalNotificationSettingsConditionInput
) {
  updateUserExternalNotificationSettings(input: $input, condition: $condition) {
    id
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    extNotificationChannel
    extUserID
    isEnabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserExternalNotificationSettingsMutationVariables,
  APITypes.UpdateUserExternalNotificationSettingsMutation
>;
export const deleteUserExternalNotificationSettings = /* GraphQL */ `mutation DeleteUserExternalNotificationSettings(
  $input: DeleteUserExternalNotificationSettingsInput!
  $condition: ModelUserExternalNotificationSettingsConditionInput
) {
  deleteUserExternalNotificationSettings(input: $input, condition: $condition) {
    id
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    extNotificationChannel
    extUserID
    isEnabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserExternalNotificationSettingsMutationVariables,
  APITypes.DeleteUserExternalNotificationSettingsMutation
>;
export const createUserRating = /* GraphQL */ `mutation CreateUserRating(
  $input: CreateUserRatingInput!
  $condition: ModelUserRatingConditionInput
) {
  createUserRating(input: $input, condition: $condition) {
    id
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    organizationGroup
    ratingValue
    comment
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserRatingMutationVariables,
  APITypes.CreateUserRatingMutation
>;
export const updateUserRating = /* GraphQL */ `mutation UpdateUserRating(
  $input: UpdateUserRatingInput!
  $condition: ModelUserRatingConditionInput
) {
  updateUserRating(input: $input, condition: $condition) {
    id
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    organizationGroup
    ratingValue
    comment
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserRatingMutationVariables,
  APITypes.UpdateUserRatingMutation
>;
export const deleteUserRating = /* GraphQL */ `mutation DeleteUserRating(
  $input: DeleteUserRatingInput!
  $condition: ModelUserRatingConditionInput
) {
  deleteUserRating(input: $input, condition: $condition) {
    id
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    organizationGroup
    ratingValue
    comment
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserRatingMutationVariables,
  APITypes.DeleteUserRatingMutation
>;
export const createUserAggregateData = /* GraphQL */ `mutation CreateUserAggregateData(
  $input: CreateUserAggregateDataInput!
  $condition: ModelUserAggregateDataConditionInput
) {
  createUserAggregateData(input: $input, condition: $condition) {
    id
    organizationGroup
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    searchableName
    searchableDepartmentName
    expertiseNames
    interestNames
    allies
    mentors
    superMentors
    mentees
    sponsorees
    skillIds
    circleIds
    eventIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserAggregateDataMutationVariables,
  APITypes.CreateUserAggregateDataMutation
>;
export const updateUserAggregateData = /* GraphQL */ `mutation UpdateUserAggregateData(
  $input: UpdateUserAggregateDataInput!
  $condition: ModelUserAggregateDataConditionInput
) {
  updateUserAggregateData(input: $input, condition: $condition) {
    id
    organizationGroup
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    searchableName
    searchableDepartmentName
    expertiseNames
    interestNames
    allies
    mentors
    superMentors
    mentees
    sponsorees
    skillIds
    circleIds
    eventIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserAggregateDataMutationVariables,
  APITypes.UpdateUserAggregateDataMutation
>;
export const deleteUserAggregateData = /* GraphQL */ `mutation DeleteUserAggregateData(
  $input: DeleteUserAggregateDataInput!
  $condition: ModelUserAggregateDataConditionInput
) {
  deleteUserAggregateData(input: $input, condition: $condition) {
    id
    organizationGroup
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    searchableName
    searchableDepartmentName
    expertiseNames
    interestNames
    allies
    mentors
    superMentors
    mentees
    sponsorees
    skillIds
    circleIds
    eventIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserAggregateDataMutationVariables,
  APITypes.DeleteUserAggregateDataMutation
>;
export const createUserPointsLogs = /* GraphQL */ `mutation CreateUserPointsLogs(
  $input: CreateUserPointsLogsInput!
  $condition: ModelUserPointsLogsConditionInput
) {
  createUserPointsLogs(input: $input, condition: $condition) {
    id
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    otherUserID
    organizationGroup
    amount
    amountBefore
    amountAfter
    lifetimePoints
    title
    description
    referenceType
    eventType
    referenceID
    eventID
    dynamoEventID
    tableARN
    linkType
    linkID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserPointsLogsMutationVariables,
  APITypes.CreateUserPointsLogsMutation
>;
export const updateUserPointsLogs = /* GraphQL */ `mutation UpdateUserPointsLogs(
  $input: UpdateUserPointsLogsInput!
  $condition: ModelUserPointsLogsConditionInput
) {
  updateUserPointsLogs(input: $input, condition: $condition) {
    id
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    otherUserID
    organizationGroup
    amount
    amountBefore
    amountAfter
    lifetimePoints
    title
    description
    referenceType
    eventType
    referenceID
    eventID
    dynamoEventID
    tableARN
    linkType
    linkID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserPointsLogsMutationVariables,
  APITypes.UpdateUserPointsLogsMutation
>;
export const deleteUserPointsLogs = /* GraphQL */ `mutation DeleteUserPointsLogs(
  $input: DeleteUserPointsLogsInput!
  $condition: ModelUserPointsLogsConditionInput
) {
  deleteUserPointsLogs(input: $input, condition: $condition) {
    id
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    otherUserID
    organizationGroup
    amount
    amountBefore
    amountAfter
    lifetimePoints
    title
    description
    referenceType
    eventType
    referenceID
    eventID
    dynamoEventID
    tableARN
    linkType
    linkID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserPointsLogsMutationVariables,
  APITypes.DeleteUserPointsLogsMutation
>;
export const createOrganization = /* GraphQL */ `mutation CreateOrganization(
  $input: CreateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  createOrganization(input: $input, condition: $condition) {
    id
    name
    domain
    isPremium
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrganizationMutationVariables,
  APITypes.CreateOrganizationMutation
>;
export const updateOrganization = /* GraphQL */ `mutation UpdateOrganization(
  $input: UpdateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  updateOrganization(input: $input, condition: $condition) {
    id
    name
    domain
    isPremium
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrganizationMutationVariables,
  APITypes.UpdateOrganizationMutation
>;
export const deleteOrganization = /* GraphQL */ `mutation DeleteOrganization(
  $input: DeleteOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  deleteOrganization(input: $input, condition: $condition) {
    id
    name
    domain
    isPremium
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrganizationMutationVariables,
  APITypes.DeleteOrganizationMutation
>;
export const createOrganizationSetting = /* GraphQL */ `mutation CreateOrganizationSetting(
  $input: CreateOrganizationSettingInput!
  $condition: ModelOrganizationSettingConditionInput
) {
  createOrganizationSetting(input: $input, condition: $condition) {
    id
    organizationGroup
    updatedBy
    disclaimer
    waivers
    privacyPolicy
    termsConditions
    allowAllCreateCircle
    allowAllCreateEvent
    maxNoOfMinIntroducers
    onboarding {
      key
      value
      __typename
    }
    pointTiers {
      platinum
      gold
      silver
      bronze
      __typename
    }
    slackBotToken
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrganizationSettingMutationVariables,
  APITypes.CreateOrganizationSettingMutation
>;
export const updateOrganizationSetting = /* GraphQL */ `mutation UpdateOrganizationSetting(
  $input: UpdateOrganizationSettingInput!
  $condition: ModelOrganizationSettingConditionInput
) {
  updateOrganizationSetting(input: $input, condition: $condition) {
    id
    organizationGroup
    updatedBy
    disclaimer
    waivers
    privacyPolicy
    termsConditions
    allowAllCreateCircle
    allowAllCreateEvent
    maxNoOfMinIntroducers
    onboarding {
      key
      value
      __typename
    }
    pointTiers {
      platinum
      gold
      silver
      bronze
      __typename
    }
    slackBotToken
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrganizationSettingMutationVariables,
  APITypes.UpdateOrganizationSettingMutation
>;
export const deleteOrganizationSetting = /* GraphQL */ `mutation DeleteOrganizationSetting(
  $input: DeleteOrganizationSettingInput!
  $condition: ModelOrganizationSettingConditionInput
) {
  deleteOrganizationSetting(input: $input, condition: $condition) {
    id
    organizationGroup
    updatedBy
    disclaimer
    waivers
    privacyPolicy
    termsConditions
    allowAllCreateCircle
    allowAllCreateEvent
    maxNoOfMinIntroducers
    onboarding {
      key
      value
      __typename
    }
    pointTiers {
      platinum
      gold
      silver
      bronze
      __typename
    }
    slackBotToken
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrganizationSettingMutationVariables,
  APITypes.DeleteOrganizationSettingMutation
>;
export const createDepartment = /* GraphQL */ `mutation CreateDepartment(
  $input: CreateDepartmentInput!
  $condition: ModelDepartmentConditionInput
) {
  createDepartment(input: $input, condition: $condition) {
    id
    name
    description
    organizationGroup
    skillTracks {
      items {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    levels {
      items {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDepartmentMutationVariables,
  APITypes.CreateDepartmentMutation
>;
export const updateDepartment = /* GraphQL */ `mutation UpdateDepartment(
  $input: UpdateDepartmentInput!
  $condition: ModelDepartmentConditionInput
) {
  updateDepartment(input: $input, condition: $condition) {
    id
    name
    description
    organizationGroup
    skillTracks {
      items {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    levels {
      items {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDepartmentMutationVariables,
  APITypes.UpdateDepartmentMutation
>;
export const deleteDepartment = /* GraphQL */ `mutation DeleteDepartment(
  $input: DeleteDepartmentInput!
  $condition: ModelDepartmentConditionInput
) {
  deleteDepartment(input: $input, condition: $condition) {
    id
    name
    description
    organizationGroup
    skillTracks {
      items {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    levels {
      items {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDepartmentMutationVariables,
  APITypes.DeleteDepartmentMutation
>;
export const createChampion = /* GraphQL */ `mutation CreateChampion(
  $input: CreateChampionInput!
  $condition: ModelChampionConditionInput
) {
  createChampion(input: $input, condition: $condition) {
    id
    organizationGroup
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    status
    requestMessage
    approvedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChampionMutationVariables,
  APITypes.CreateChampionMutation
>;
export const updateChampion = /* GraphQL */ `mutation UpdateChampion(
  $input: UpdateChampionInput!
  $condition: ModelChampionConditionInput
) {
  updateChampion(input: $input, condition: $condition) {
    id
    organizationGroup
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    status
    requestMessage
    approvedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChampionMutationVariables,
  APITypes.UpdateChampionMutation
>;
export const deleteChampion = /* GraphQL */ `mutation DeleteChampion(
  $input: DeleteChampionInput!
  $condition: ModelChampionConditionInput
) {
  deleteChampion(input: $input, condition: $condition) {
    id
    organizationGroup
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    status
    requestMessage
    approvedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChampionMutationVariables,
  APITypes.DeleteChampionMutation
>;
export const createDepartmentLevel = /* GraphQL */ `mutation CreateDepartmentLevel(
  $input: CreateDepartmentLevelInput!
  $condition: ModelDepartmentLevelConditionInput
) {
  createDepartmentLevel(input: $input, condition: $condition) {
    id
    organizationGroup
    departmentId
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    name
    rank
    skills {
      items {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDepartmentLevelMutationVariables,
  APITypes.CreateDepartmentLevelMutation
>;
export const updateDepartmentLevel = /* GraphQL */ `mutation UpdateDepartmentLevel(
  $input: UpdateDepartmentLevelInput!
  $condition: ModelDepartmentLevelConditionInput
) {
  updateDepartmentLevel(input: $input, condition: $condition) {
    id
    organizationGroup
    departmentId
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    name
    rank
    skills {
      items {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDepartmentLevelMutationVariables,
  APITypes.UpdateDepartmentLevelMutation
>;
export const deleteDepartmentLevel = /* GraphQL */ `mutation DeleteDepartmentLevel(
  $input: DeleteDepartmentLevelInput!
  $condition: ModelDepartmentLevelConditionInput
) {
  deleteDepartmentLevel(input: $input, condition: $condition) {
    id
    organizationGroup
    departmentId
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    name
    rank
    skills {
      items {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDepartmentLevelMutationVariables,
  APITypes.DeleteDepartmentLevelMutation
>;
export const createCircle = /* GraphQL */ `mutation CreateCircle(
  $input: CreateCircleInput!
  $condition: ModelCircleConditionInput
) {
  createCircle(input: $input, condition: $condition) {
    id
    name
    description
    imageUrl
    privacy
    event {
      items {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interest
    organizationGroup
    admins
    members {
      items {
        id
        organizationGroup
        role
        status
        requestStatus
        circleUserCircleId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        circleUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        circleUserInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    isManagedByHR
    creator
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCircleMutationVariables,
  APITypes.CreateCircleMutation
>;
export const updateCircle = /* GraphQL */ `mutation UpdateCircle(
  $input: UpdateCircleInput!
  $condition: ModelCircleConditionInput
) {
  updateCircle(input: $input, condition: $condition) {
    id
    name
    description
    imageUrl
    privacy
    event {
      items {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interest
    organizationGroup
    admins
    members {
      items {
        id
        organizationGroup
        role
        status
        requestStatus
        circleUserCircleId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        circleUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        circleUserInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    isManagedByHR
    creator
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCircleMutationVariables,
  APITypes.UpdateCircleMutation
>;
export const deleteCircle = /* GraphQL */ `mutation DeleteCircle(
  $input: DeleteCircleInput!
  $condition: ModelCircleConditionInput
) {
  deleteCircle(input: $input, condition: $condition) {
    id
    name
    description
    imageUrl
    privacy
    event {
      items {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interest
    organizationGroup
    admins
    members {
      items {
        id
        organizationGroup
        role
        status
        requestStatus
        circleUserCircleId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        circleUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        circleUserInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    isManagedByHR
    creator
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCircleMutationVariables,
  APITypes.DeleteCircleMutation
>;
export const createCircleUser = /* GraphQL */ `mutation CreateCircleUser(
  $input: CreateCircleUserInput!
  $condition: ModelCircleUserConditionInput
) {
  createCircleUser(input: $input, condition: $condition) {
    id
    organizationGroup
    role
    status
    requestStatus
    circleUserCircleId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circleUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    circleUserInviterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCircleUserMutationVariables,
  APITypes.CreateCircleUserMutation
>;
export const updateCircleUser = /* GraphQL */ `mutation UpdateCircleUser(
  $input: UpdateCircleUserInput!
  $condition: ModelCircleUserConditionInput
) {
  updateCircleUser(input: $input, condition: $condition) {
    id
    organizationGroup
    role
    status
    requestStatus
    circleUserCircleId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circleUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    circleUserInviterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCircleUserMutationVariables,
  APITypes.UpdateCircleUserMutation
>;
export const deleteCircleUser = /* GraphQL */ `mutation DeleteCircleUser(
  $input: DeleteCircleUserInput!
  $condition: ModelCircleUserConditionInput
) {
  deleteCircleUser(input: $input, condition: $condition) {
    id
    organizationGroup
    role
    status
    requestStatus
    circleUserCircleId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circleUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    circleUserInviterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCircleUserMutationVariables,
  APITypes.DeleteCircleUserMutation
>;
export const createVisit = /* GraphQL */ `mutation CreateVisit(
  $input: CreateVisitInput!
  $condition: ModelVisitConditionInput
) {
  createVisit(input: $input, condition: $condition) {
    id
    contextId
    contextType
    visitorId
    organizationGroup
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVisitMutationVariables,
  APITypes.CreateVisitMutation
>;
export const updateVisit = /* GraphQL */ `mutation UpdateVisit(
  $input: UpdateVisitInput!
  $condition: ModelVisitConditionInput
) {
  updateVisit(input: $input, condition: $condition) {
    id
    contextId
    contextType
    visitorId
    organizationGroup
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVisitMutationVariables,
  APITypes.UpdateVisitMutation
>;
export const deleteVisit = /* GraphQL */ `mutation DeleteVisit(
  $input: DeleteVisitInput!
  $condition: ModelVisitConditionInput
) {
  deleteVisit(input: $input, condition: $condition) {
    id
    contextId
    contextType
    visitorId
    organizationGroup
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVisitMutationVariables,
  APITypes.DeleteVisitMutation
>;
export const createTag = /* GraphQL */ `mutation CreateTag(
  $input: CreateTagInput!
  $condition: ModelTagConditionInput
) {
  createTag(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    type
    category
    tagCategoryId
    tagCategory {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTagMutationVariables,
  APITypes.CreateTagMutation
>;
export const updateTag = /* GraphQL */ `mutation UpdateTag(
  $input: UpdateTagInput!
  $condition: ModelTagConditionInput
) {
  updateTag(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    type
    category
    tagCategoryId
    tagCategory {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTagMutationVariables,
  APITypes.UpdateTagMutation
>;
export const deleteTag = /* GraphQL */ `mutation DeleteTag(
  $input: DeleteTagInput!
  $condition: ModelTagConditionInput
) {
  deleteTag(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    type
    category
    tagCategoryId
    tagCategory {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTagMutationVariables,
  APITypes.DeleteTagMutation
>;
export const createTagCategory = /* GraphQL */ `mutation CreateTagCategory(
  $input: CreateTagCategoryInput!
  $condition: ModelTagCategoryConditionInput
) {
  createTagCategory(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    tags {
      items {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTagCategoryMutationVariables,
  APITypes.CreateTagCategoryMutation
>;
export const updateTagCategory = /* GraphQL */ `mutation UpdateTagCategory(
  $input: UpdateTagCategoryInput!
  $condition: ModelTagCategoryConditionInput
) {
  updateTagCategory(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    tags {
      items {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTagCategoryMutationVariables,
  APITypes.UpdateTagCategoryMutation
>;
export const deleteTagCategory = /* GraphQL */ `mutation DeleteTagCategory(
  $input: DeleteTagCategoryInput!
  $condition: ModelTagCategoryConditionInput
) {
  deleteTagCategory(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    tags {
      items {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTagCategoryMutationVariables,
  APITypes.DeleteTagCategoryMutation
>;
export const createSkillTrack = /* GraphQL */ `mutation CreateSkillTrack(
  $input: CreateSkillTrackInput!
  $condition: ModelSkillTrackConditionInput
) {
  createSkillTrack(input: $input, condition: $condition) {
    id
    organizationGroup
    departmentId
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tag {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillTrackTagId
    name
    color
    skills {
      items {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillTrackMutationVariables,
  APITypes.CreateSkillTrackMutation
>;
export const updateSkillTrack = /* GraphQL */ `mutation UpdateSkillTrack(
  $input: UpdateSkillTrackInput!
  $condition: ModelSkillTrackConditionInput
) {
  updateSkillTrack(input: $input, condition: $condition) {
    id
    organizationGroup
    departmentId
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tag {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillTrackTagId
    name
    color
    skills {
      items {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillTrackMutationVariables,
  APITypes.UpdateSkillTrackMutation
>;
export const deleteSkillTrack = /* GraphQL */ `mutation DeleteSkillTrack(
  $input: DeleteSkillTrackInput!
  $condition: ModelSkillTrackConditionInput
) {
  deleteSkillTrack(input: $input, condition: $condition) {
    id
    organizationGroup
    departmentId
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tag {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillTrackTagId
    name
    color
    skills {
      items {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillTrackMutationVariables,
  APITypes.DeleteSkillTrackMutation
>;
export const createSkill = /* GraphQL */ `mutation CreateSkill(
  $input: CreateSkillInput!
  $condition: ModelSkillConditionInput
) {
  createSkill(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillDepartmentId
    trackOrder
    points
    assignees {
      items {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    skillTrackId
    skillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    departmentlevelId
    departmentlevel {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      rank
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    level
    levelRank
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillMutationVariables,
  APITypes.CreateSkillMutation
>;
export const updateSkill = /* GraphQL */ `mutation UpdateSkill(
  $input: UpdateSkillInput!
  $condition: ModelSkillConditionInput
) {
  updateSkill(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillDepartmentId
    trackOrder
    points
    assignees {
      items {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    skillTrackId
    skillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    departmentlevelId
    departmentlevel {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      rank
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    level
    levelRank
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillMutationVariables,
  APITypes.UpdateSkillMutation
>;
export const deleteSkill = /* GraphQL */ `mutation DeleteSkill(
  $input: DeleteSkillInput!
  $condition: ModelSkillConditionInput
) {
  deleteSkill(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillDepartmentId
    trackOrder
    points
    assignees {
      items {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    skillTrackId
    skillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    departmentlevelId
    departmentlevel {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      rank
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    level
    levelRank
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillMutationVariables,
  APITypes.DeleteSkillMutation
>;
export const createSkillUser = /* GraphQL */ `mutation CreateSkillUser(
  $input: CreateSkillUserInput!
  $condition: ModelSkillUserConditionInput
) {
  createSkillUser(input: $input, condition: $condition) {
    id
    organizationGroup
    skillId
    skill {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    completedAt
    verifiers {
      items {
        id
        skillUserId
        skillUser {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillId
        organizationGroup
        verifierId
        verifier {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        rating
        message
        isHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillUserMutationVariables,
  APITypes.CreateSkillUserMutation
>;
export const updateSkillUser = /* GraphQL */ `mutation UpdateSkillUser(
  $input: UpdateSkillUserInput!
  $condition: ModelSkillUserConditionInput
) {
  updateSkillUser(input: $input, condition: $condition) {
    id
    organizationGroup
    skillId
    skill {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    completedAt
    verifiers {
      items {
        id
        skillUserId
        skillUser {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillId
        organizationGroup
        verifierId
        verifier {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        rating
        message
        isHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillUserMutationVariables,
  APITypes.UpdateSkillUserMutation
>;
export const deleteSkillUser = /* GraphQL */ `mutation DeleteSkillUser(
  $input: DeleteSkillUserInput!
  $condition: ModelSkillUserConditionInput
) {
  deleteSkillUser(input: $input, condition: $condition) {
    id
    organizationGroup
    skillId
    skill {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    completedAt
    verifiers {
      items {
        id
        skillUserId
        skillUser {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillId
        organizationGroup
        verifierId
        verifier {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        rating
        message
        isHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillUserMutationVariables,
  APITypes.DeleteSkillUserMutation
>;
export const createSkillUserVerifier = /* GraphQL */ `mutation CreateSkillUserVerifier(
  $input: CreateSkillUserVerifierInput!
  $condition: ModelSkillUserVerifierConditionInput
) {
  createSkillUserVerifier(input: $input, condition: $condition) {
    id
    skillUserId
    skillUser {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillId
    organizationGroup
    verifierId
    verifier {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    rating
    message
    isHR
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSkillUserVerifierMutationVariables,
  APITypes.CreateSkillUserVerifierMutation
>;
export const updateSkillUserVerifier = /* GraphQL */ `mutation UpdateSkillUserVerifier(
  $input: UpdateSkillUserVerifierInput!
  $condition: ModelSkillUserVerifierConditionInput
) {
  updateSkillUserVerifier(input: $input, condition: $condition) {
    id
    skillUserId
    skillUser {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillId
    organizationGroup
    verifierId
    verifier {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    rating
    message
    isHR
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSkillUserVerifierMutationVariables,
  APITypes.UpdateSkillUserVerifierMutation
>;
export const deleteSkillUserVerifier = /* GraphQL */ `mutation DeleteSkillUserVerifier(
  $input: DeleteSkillUserVerifierInput!
  $condition: ModelSkillUserVerifierConditionInput
) {
  deleteSkillUserVerifier(input: $input, condition: $condition) {
    id
    skillUserId
    skillUser {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillId
    organizationGroup
    verifierId
    verifier {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    rating
    message
    isHR
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSkillUserVerifierMutationVariables,
  APITypes.DeleteSkillUserVerifierMutation
>;
export const createConnection = /* GraphQL */ `mutation CreateConnection(
  $input: CreateConnectionInput!
  $condition: ModelConnectionConditionInput
) {
  createConnection(input: $input, condition: $condition) {
    id
    description
    status
    approvedAt
    organizationGroup
    connectionUserFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userFromRequestType
    userFromRequestStatus
    connectionUserToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    userToRequestType
    userToRequestStatus
    introductionRequests {
      items {
        id
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToType
        introducer {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        introductionRequestUserFromId
        introductionRequestUserToId
        introducerId
        reason
        status
        message
        connectionId
        connection {
          id
          description
          status
          approvedAt
          organizationGroup
          connectionUserFromId
          userFromType
          userFromRequestType
          userFromRequestStatus
          connectionUserToId
          userToType
          userToRequestType
          userToRequestStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        introductionRequestIntroducerId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConnectionMutationVariables,
  APITypes.CreateConnectionMutation
>;
export const updateConnection = /* GraphQL */ `mutation UpdateConnection(
  $input: UpdateConnectionInput!
  $condition: ModelConnectionConditionInput
) {
  updateConnection(input: $input, condition: $condition) {
    id
    description
    status
    approvedAt
    organizationGroup
    connectionUserFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userFromRequestType
    userFromRequestStatus
    connectionUserToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    userToRequestType
    userToRequestStatus
    introductionRequests {
      items {
        id
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToType
        introducer {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        introductionRequestUserFromId
        introductionRequestUserToId
        introducerId
        reason
        status
        message
        connectionId
        connection {
          id
          description
          status
          approvedAt
          organizationGroup
          connectionUserFromId
          userFromType
          userFromRequestType
          userFromRequestStatus
          connectionUserToId
          userToType
          userToRequestType
          userToRequestStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        introductionRequestIntroducerId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConnectionMutationVariables,
  APITypes.UpdateConnectionMutation
>;
export const deleteConnection = /* GraphQL */ `mutation DeleteConnection(
  $input: DeleteConnectionInput!
  $condition: ModelConnectionConditionInput
) {
  deleteConnection(input: $input, condition: $condition) {
    id
    description
    status
    approvedAt
    organizationGroup
    connectionUserFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userFromRequestType
    userFromRequestStatus
    connectionUserToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    userToRequestType
    userToRequestStatus
    introductionRequests {
      items {
        id
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToType
        introducer {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        introductionRequestUserFromId
        introductionRequestUserToId
        introducerId
        reason
        status
        message
        connectionId
        connection {
          id
          description
          status
          approvedAt
          organizationGroup
          connectionUserFromId
          userFromType
          userFromRequestType
          userFromRequestStatus
          connectionUserToId
          userToType
          userToRequestType
          userToRequestStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        introductionRequestIntroducerId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteConnectionMutationVariables,
  APITypes.DeleteConnectionMutation
>;
export const createNotification = /* GraphQL */ `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    description
    message
    status
    userFrom
    userTo
    referenceType
    isFromHR
    createdAt
    referenceID
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    description
    message
    status
    userFrom
    userTo
    referenceType
    isFromHR
    createdAt
    referenceID
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const deleteNotification = /* GraphQL */ `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    description
    message
    status
    userFrom
    userTo
    referenceType
    isFromHR
    createdAt
    referenceID
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
export const createContextFileResources = /* GraphQL */ `mutation CreateContextFileResources(
  $input: CreateContextFileResourcesInput!
  $condition: ModelContextFileResourcesConditionInput
) {
  createContextFileResources(input: $input, condition: $condition) {
    id
    uploader
    fileUrl
    fileName
    fileType
    contextType
    contextID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateContextFileResourcesMutationVariables,
  APITypes.CreateContextFileResourcesMutation
>;
export const updateContextFileResources = /* GraphQL */ `mutation UpdateContextFileResources(
  $input: UpdateContextFileResourcesInput!
  $condition: ModelContextFileResourcesConditionInput
) {
  updateContextFileResources(input: $input, condition: $condition) {
    id
    uploader
    fileUrl
    fileName
    fileType
    contextType
    contextID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateContextFileResourcesMutationVariables,
  APITypes.UpdateContextFileResourcesMutation
>;
export const deleteContextFileResources = /* GraphQL */ `mutation DeleteContextFileResources(
  $input: DeleteContextFileResourcesInput!
  $condition: ModelContextFileResourcesConditionInput
) {
  deleteContextFileResources(input: $input, condition: $condition) {
    id
    uploader
    fileUrl
    fileName
    fileType
    contextType
    contextID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteContextFileResourcesMutationVariables,
  APITypes.DeleteContextFileResourcesMutation
>;
export const createEndorsement = /* GraphQL */ `mutation CreateEndorsement(
  $input: CreateEndorsementInput!
  $condition: ModelEndorsementConditionInput
) {
  createEndorsement(input: $input, condition: $condition) {
    id
    description
    status
    endorsementAssignedToId
    endorsementCreatedById
    previousEndorsementId
    previousEndorsement {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdBy {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEndorsementMutationVariables,
  APITypes.CreateEndorsementMutation
>;
export const updateEndorsement = /* GraphQL */ `mutation UpdateEndorsement(
  $input: UpdateEndorsementInput!
  $condition: ModelEndorsementConditionInput
) {
  updateEndorsement(input: $input, condition: $condition) {
    id
    description
    status
    endorsementAssignedToId
    endorsementCreatedById
    previousEndorsementId
    previousEndorsement {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdBy {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEndorsementMutationVariables,
  APITypes.UpdateEndorsementMutation
>;
export const deleteEndorsement = /* GraphQL */ `mutation DeleteEndorsement(
  $input: DeleteEndorsementInput!
  $condition: ModelEndorsementConditionInput
) {
  deleteEndorsement(input: $input, condition: $condition) {
    id
    description
    status
    endorsementAssignedToId
    endorsementCreatedById
    previousEndorsementId
    previousEndorsement {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdBy {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEndorsementMutationVariables,
  APITypes.DeleteEndorsementMutation
>;
export const createEvent = /* GraphQL */ `mutation CreateEvent(
  $input: CreateEventInput!
  $condition: ModelEventConditionInput
) {
  createEvent(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    imageUrl
    startTime
    endTime
    circleEventId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    attendee {
      items {
        id
        organizationGroup
        eventAttendeeId
        event {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        eventAttendeeUserId
        status
        requestStatus
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        eventAttendeeInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interests
    privacy
    admins
    timezone
    location
    createdAt
    isManagedByHR
    owner
    isHidden
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventMutationVariables,
  APITypes.CreateEventMutation
>;
export const updateEvent = /* GraphQL */ `mutation UpdateEvent(
  $input: UpdateEventInput!
  $condition: ModelEventConditionInput
) {
  updateEvent(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    imageUrl
    startTime
    endTime
    circleEventId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    attendee {
      items {
        id
        organizationGroup
        eventAttendeeId
        event {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        eventAttendeeUserId
        status
        requestStatus
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        eventAttendeeInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interests
    privacy
    admins
    timezone
    location
    createdAt
    isManagedByHR
    owner
    isHidden
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventMutationVariables,
  APITypes.UpdateEventMutation
>;
export const deleteEvent = /* GraphQL */ `mutation DeleteEvent(
  $input: DeleteEventInput!
  $condition: ModelEventConditionInput
) {
  deleteEvent(input: $input, condition: $condition) {
    id
    organizationGroup
    name
    description
    imageUrl
    startTime
    endTime
    circleEventId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    attendee {
      items {
        id
        organizationGroup
        eventAttendeeId
        event {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        eventAttendeeUserId
        status
        requestStatus
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        eventAttendeeInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interests
    privacy
    admins
    timezone
    location
    createdAt
    isManagedByHR
    owner
    isHidden
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventMutationVariables,
  APITypes.DeleteEventMutation
>;
export const createEventAttendee = /* GraphQL */ `mutation CreateEventAttendee(
  $input: CreateEventAttendeeInput!
  $condition: ModelEventAttendeeConditionInput
) {
  createEventAttendee(input: $input, condition: $condition) {
    id
    organizationGroup
    eventAttendeeId
    event {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    eventAttendeeUserId
    status
    requestStatus
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    eventAttendeeInviterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventAttendeeMutationVariables,
  APITypes.CreateEventAttendeeMutation
>;
export const updateEventAttendee = /* GraphQL */ `mutation UpdateEventAttendee(
  $input: UpdateEventAttendeeInput!
  $condition: ModelEventAttendeeConditionInput
) {
  updateEventAttendee(input: $input, condition: $condition) {
    id
    organizationGroup
    eventAttendeeId
    event {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    eventAttendeeUserId
    status
    requestStatus
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    eventAttendeeInviterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventAttendeeMutationVariables,
  APITypes.UpdateEventAttendeeMutation
>;
export const deleteEventAttendee = /* GraphQL */ `mutation DeleteEventAttendee(
  $input: DeleteEventAttendeeInput!
  $condition: ModelEventAttendeeConditionInput
) {
  deleteEventAttendee(input: $input, condition: $condition) {
    id
    organizationGroup
    eventAttendeeId
    event {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    eventAttendeeUserId
    status
    requestStatus
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    eventAttendeeInviterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventAttendeeMutationVariables,
  APITypes.DeleteEventAttendeeMutation
>;
export const createRedFlag = /* GraphQL */ `mutation CreateRedFlag(
  $input: CreateRedFlagInput!
  $condition: ModelRedFlagConditionInput
) {
  createRedFlag(input: $input, condition: $condition) {
    id
    organizationGroup
    description
    attachmentUrl
    referenceType
    referenceId
    referenceName
    reporter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    issue
    status
    isCompleted
    completedAt
    isAnonymous
    comment
    comments {
      name
      message
      createdAt
      review
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    redFlagReporterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRedFlagMutationVariables,
  APITypes.CreateRedFlagMutation
>;
export const updateRedFlag = /* GraphQL */ `mutation UpdateRedFlag(
  $input: UpdateRedFlagInput!
  $condition: ModelRedFlagConditionInput
) {
  updateRedFlag(input: $input, condition: $condition) {
    id
    organizationGroup
    description
    attachmentUrl
    referenceType
    referenceId
    referenceName
    reporter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    issue
    status
    isCompleted
    completedAt
    isAnonymous
    comment
    comments {
      name
      message
      createdAt
      review
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    redFlagReporterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRedFlagMutationVariables,
  APITypes.UpdateRedFlagMutation
>;
export const deleteRedFlag = /* GraphQL */ `mutation DeleteRedFlag(
  $input: DeleteRedFlagInput!
  $condition: ModelRedFlagConditionInput
) {
  deleteRedFlag(input: $input, condition: $condition) {
    id
    organizationGroup
    description
    attachmentUrl
    referenceType
    referenceId
    referenceName
    reporter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    issue
    status
    isCompleted
    completedAt
    isAnonymous
    comment
    comments {
      name
      message
      createdAt
      review
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    redFlagReporterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRedFlagMutationVariables,
  APITypes.DeleteRedFlagMutation
>;
export const createReward = /* GraphQL */ `mutation CreateReward(
  $input: CreateRewardInput!
  $condition: ModelRewardConditionInput
) {
  createReward(input: $input, condition: $condition) {
    id
    organizationGroup
    title
    description
    isActive
    points
    pointsDiscount
    imageUrl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRewardMutationVariables,
  APITypes.CreateRewardMutation
>;
export const updateReward = /* GraphQL */ `mutation UpdateReward(
  $input: UpdateRewardInput!
  $condition: ModelRewardConditionInput
) {
  updateReward(input: $input, condition: $condition) {
    id
    organizationGroup
    title
    description
    isActive
    points
    pointsDiscount
    imageUrl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRewardMutationVariables,
  APITypes.UpdateRewardMutation
>;
export const deleteReward = /* GraphQL */ `mutation DeleteReward(
  $input: DeleteRewardInput!
  $condition: ModelRewardConditionInput
) {
  deleteReward(input: $input, condition: $condition) {
    id
    organizationGroup
    title
    description
    isActive
    points
    pointsDiscount
    imageUrl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRewardMutationVariables,
  APITypes.DeleteRewardMutation
>;
export const createRewardUser = /* GraphQL */ `mutation CreateRewardUser(
  $input: CreateRewardUserInput!
  $condition: ModelRewardUserConditionInput
) {
  createRewardUser(input: $input, condition: $condition) {
    id
    reward {
      id
      organizationGroup
      title
      description
      isActive
      points
      pointsDiscount
      imageUrl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    rewardID
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    isUsed
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRewardUserMutationVariables,
  APITypes.CreateRewardUserMutation
>;
export const updateRewardUser = /* GraphQL */ `mutation UpdateRewardUser(
  $input: UpdateRewardUserInput!
  $condition: ModelRewardUserConditionInput
) {
  updateRewardUser(input: $input, condition: $condition) {
    id
    reward {
      id
      organizationGroup
      title
      description
      isActive
      points
      pointsDiscount
      imageUrl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    rewardID
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    isUsed
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRewardUserMutationVariables,
  APITypes.UpdateRewardUserMutation
>;
export const deleteRewardUser = /* GraphQL */ `mutation DeleteRewardUser(
  $input: DeleteRewardUserInput!
  $condition: ModelRewardUserConditionInput
) {
  deleteRewardUser(input: $input, condition: $condition) {
    id
    reward {
      id
      organizationGroup
      title
      description
      isActive
      points
      pointsDiscount
      imageUrl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    rewardID
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    isUsed
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRewardUserMutationVariables,
  APITypes.DeleteRewardUserMutation
>;
export const createPointRewardConfiguration = /* GraphQL */ `mutation CreatePointRewardConfiguration(
  $input: CreatePointRewardConfigurationInput!
  $condition: ModelPointRewardConfigurationConditionInput
) {
  createPointRewardConfiguration(input: $input, condition: $condition) {
    id
    organizationGroup
    amount
    EventType
    createdAt
    category
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePointRewardConfigurationMutationVariables,
  APITypes.CreatePointRewardConfigurationMutation
>;
export const updatePointRewardConfiguration = /* GraphQL */ `mutation UpdatePointRewardConfiguration(
  $input: UpdatePointRewardConfigurationInput!
  $condition: ModelPointRewardConfigurationConditionInput
) {
  updatePointRewardConfiguration(input: $input, condition: $condition) {
    id
    organizationGroup
    amount
    EventType
    createdAt
    category
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePointRewardConfigurationMutationVariables,
  APITypes.UpdatePointRewardConfigurationMutation
>;
export const deletePointRewardConfiguration = /* GraphQL */ `mutation DeletePointRewardConfiguration(
  $input: DeletePointRewardConfigurationInput!
  $condition: ModelPointRewardConfigurationConditionInput
) {
  deletePointRewardConfiguration(input: $input, condition: $condition) {
    id
    organizationGroup
    amount
    EventType
    createdAt
    category
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePointRewardConfigurationMutationVariables,
  APITypes.DeletePointRewardConfigurationMutation
>;
export const createCommonGround = /* GraphQL */ `mutation CreateCommonGround(
  $input: CreateCommonGroundInput!
  $condition: ModelCommonGroundConditionInput
) {
  createCommonGround(input: $input, condition: $condition) {
    id
    userFrom
    userTo
    userToFirstName
    userToLastName
    userToEmail
    organizationGroup
    connectionId
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCommonGroundMutationVariables,
  APITypes.CreateCommonGroundMutation
>;
export const updateCommonGround = /* GraphQL */ `mutation UpdateCommonGround(
  $input: UpdateCommonGroundInput!
  $condition: ModelCommonGroundConditionInput
) {
  updateCommonGround(input: $input, condition: $condition) {
    id
    userFrom
    userTo
    userToFirstName
    userToLastName
    userToEmail
    organizationGroup
    connectionId
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCommonGroundMutationVariables,
  APITypes.UpdateCommonGroundMutation
>;
export const deleteCommonGround = /* GraphQL */ `mutation DeleteCommonGround(
  $input: DeleteCommonGroundInput!
  $condition: ModelCommonGroundConditionInput
) {
  deleteCommonGround(input: $input, condition: $condition) {
    id
    userFrom
    userTo
    userToFirstName
    userToLastName
    userToEmail
    organizationGroup
    connectionId
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCommonGroundMutationVariables,
  APITypes.DeleteCommonGroundMutation
>;
export const createCommonGroundContext = /* GraphQL */ `mutation CreateCommonGroundContext(
  $input: CreateCommonGroundContextInput!
  $condition: ModelCommonGroundContextConditionInput
) {
  createCommonGroundContext(input: $input, condition: $condition) {
    id
    userFrom
    organizationGroup
    referenceId
    referenceType
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCommonGroundContextMutationVariables,
  APITypes.CreateCommonGroundContextMutation
>;
export const updateCommonGroundContext = /* GraphQL */ `mutation UpdateCommonGroundContext(
  $input: UpdateCommonGroundContextInput!
  $condition: ModelCommonGroundContextConditionInput
) {
  updateCommonGroundContext(input: $input, condition: $condition) {
    id
    userFrom
    organizationGroup
    referenceId
    referenceType
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCommonGroundContextMutationVariables,
  APITypes.UpdateCommonGroundContextMutation
>;
export const deleteCommonGroundContext = /* GraphQL */ `mutation DeleteCommonGroundContext(
  $input: DeleteCommonGroundContextInput!
  $condition: ModelCommonGroundContextConditionInput
) {
  deleteCommonGroundContext(input: $input, condition: $condition) {
    id
    userFrom
    organizationGroup
    referenceId
    referenceType
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCommonGroundContextMutationVariables,
  APITypes.DeleteCommonGroundContextMutation
>;
export const createPrivacySettings = /* GraphQL */ `mutation CreatePrivacySettings(
  $input: CreatePrivacySettingsInput!
  $condition: ModelPrivacySettingsConditionInput
) {
  createPrivacySettings(input: $input, condition: $condition) {
    id
    user
    organization {
      type
      isActivelyLooking
      __typename
    }
    industry {
      type
      isActivelyLooking
      __typename
    }
    interests {
      type
      isActivelyLooking
      __typename
    }
    birthLocation {
      type
      isActivelyLooking
      __typename
    }
    zodiacSign {
      type
      isActivelyLooking
      __typename
    }
    personalityType {
      type
      isActivelyLooking
      __typename
    }
    gender {
      type
      isActivelyLooking
      __typename
    }
    sexuality {
      type
      isActivelyLooking
      __typename
    }
    ethnicity {
      type
      isActivelyLooking
      __typename
    }
    endorsement {
      type
      isActivelyLooking
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrivacySettingsMutationVariables,
  APITypes.CreatePrivacySettingsMutation
>;
export const updatePrivacySettings = /* GraphQL */ `mutation UpdatePrivacySettings(
  $input: UpdatePrivacySettingsInput!
  $condition: ModelPrivacySettingsConditionInput
) {
  updatePrivacySettings(input: $input, condition: $condition) {
    id
    user
    organization {
      type
      isActivelyLooking
      __typename
    }
    industry {
      type
      isActivelyLooking
      __typename
    }
    interests {
      type
      isActivelyLooking
      __typename
    }
    birthLocation {
      type
      isActivelyLooking
      __typename
    }
    zodiacSign {
      type
      isActivelyLooking
      __typename
    }
    personalityType {
      type
      isActivelyLooking
      __typename
    }
    gender {
      type
      isActivelyLooking
      __typename
    }
    sexuality {
      type
      isActivelyLooking
      __typename
    }
    ethnicity {
      type
      isActivelyLooking
      __typename
    }
    endorsement {
      type
      isActivelyLooking
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrivacySettingsMutationVariables,
  APITypes.UpdatePrivacySettingsMutation
>;
export const deletePrivacySettings = /* GraphQL */ `mutation DeletePrivacySettings(
  $input: DeletePrivacySettingsInput!
  $condition: ModelPrivacySettingsConditionInput
) {
  deletePrivacySettings(input: $input, condition: $condition) {
    id
    user
    organization {
      type
      isActivelyLooking
      __typename
    }
    industry {
      type
      isActivelyLooking
      __typename
    }
    interests {
      type
      isActivelyLooking
      __typename
    }
    birthLocation {
      type
      isActivelyLooking
      __typename
    }
    zodiacSign {
      type
      isActivelyLooking
      __typename
    }
    personalityType {
      type
      isActivelyLooking
      __typename
    }
    gender {
      type
      isActivelyLooking
      __typename
    }
    sexuality {
      type
      isActivelyLooking
      __typename
    }
    ethnicity {
      type
      isActivelyLooking
      __typename
    }
    endorsement {
      type
      isActivelyLooking
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrivacySettingsMutationVariables,
  APITypes.DeletePrivacySettingsMutation
>;
export const createIntroductionRequest = /* GraphQL */ `mutation CreateIntroductionRequest(
  $input: CreateIntroductionRequestInput!
  $condition: ModelIntroductionRequestConditionInput
) {
  createIntroductionRequest(input: $input, condition: $condition) {
    id
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToType
    introducer {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    introductionRequestUserFromId
    introductionRequestUserToId
    introducerId
    reason
    status
    message
    connectionId
    connection {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    introductionRequestIntroducerId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIntroductionRequestMutationVariables,
  APITypes.CreateIntroductionRequestMutation
>;
export const updateIntroductionRequest = /* GraphQL */ `mutation UpdateIntroductionRequest(
  $input: UpdateIntroductionRequestInput!
  $condition: ModelIntroductionRequestConditionInput
) {
  updateIntroductionRequest(input: $input, condition: $condition) {
    id
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToType
    introducer {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    introductionRequestUserFromId
    introductionRequestUserToId
    introducerId
    reason
    status
    message
    connectionId
    connection {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    introductionRequestIntroducerId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIntroductionRequestMutationVariables,
  APITypes.UpdateIntroductionRequestMutation
>;
export const deleteIntroductionRequest = /* GraphQL */ `mutation DeleteIntroductionRequest(
  $input: DeleteIntroductionRequestInput!
  $condition: ModelIntroductionRequestConditionInput
) {
  deleteIntroductionRequest(input: $input, condition: $condition) {
    id
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToType
    introducer {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    introductionRequestUserFromId
    introductionRequestUserToId
    introducerId
    reason
    status
    message
    connectionId
    connection {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    introductionRequestIntroducerId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIntroductionRequestMutationVariables,
  APITypes.DeleteIntroductionRequestMutation
>;
export const createPost = /* GraphQL */ `mutation CreatePost(
  $input: CreatePostInput!
  $condition: ModelPostConditionInput
) {
  createPost(input: $input, condition: $condition) {
    id
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    postAuthorId
    contextType
    contextName
    contextPrivacy
    contextImage
    isContextHidden
    category
    contextId
    content
    likeUsers
    attachments
    createdAt
    isAuthorHR
    isContextDeleted
    isHighlight
    audienceType
    audienceID
    comments {
      items {
        id
        post {
          id
          organizationGroup
          postAuthorId
          contextType
          contextName
          contextPrivacy
          contextImage
          isContextHidden
          category
          contextId
          content
          likeUsers
          attachments
          createdAt
          isAuthorHR
          isContextDeleted
          isHighlight
          audienceType
          audienceID
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        commentPostId
        organizationGroup
        author {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        commentAuthorId
        likeUsers
        message
        isAuthorHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePostMutationVariables,
  APITypes.CreatePostMutation
>;
export const updatePost = /* GraphQL */ `mutation UpdatePost(
  $input: UpdatePostInput!
  $condition: ModelPostConditionInput
) {
  updatePost(input: $input, condition: $condition) {
    id
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    postAuthorId
    contextType
    contextName
    contextPrivacy
    contextImage
    isContextHidden
    category
    contextId
    content
    likeUsers
    attachments
    createdAt
    isAuthorHR
    isContextDeleted
    isHighlight
    audienceType
    audienceID
    comments {
      items {
        id
        post {
          id
          organizationGroup
          postAuthorId
          contextType
          contextName
          contextPrivacy
          contextImage
          isContextHidden
          category
          contextId
          content
          likeUsers
          attachments
          createdAt
          isAuthorHR
          isContextDeleted
          isHighlight
          audienceType
          audienceID
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        commentPostId
        organizationGroup
        author {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        commentAuthorId
        likeUsers
        message
        isAuthorHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePostMutationVariables,
  APITypes.UpdatePostMutation
>;
export const deletePost = /* GraphQL */ `mutation DeletePost(
  $input: DeletePostInput!
  $condition: ModelPostConditionInput
) {
  deletePost(input: $input, condition: $condition) {
    id
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    postAuthorId
    contextType
    contextName
    contextPrivacy
    contextImage
    isContextHidden
    category
    contextId
    content
    likeUsers
    attachments
    createdAt
    isAuthorHR
    isContextDeleted
    isHighlight
    audienceType
    audienceID
    comments {
      items {
        id
        post {
          id
          organizationGroup
          postAuthorId
          contextType
          contextName
          contextPrivacy
          contextImage
          isContextHidden
          category
          contextId
          content
          likeUsers
          attachments
          createdAt
          isAuthorHR
          isContextDeleted
          isHighlight
          audienceType
          audienceID
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        commentPostId
        organizationGroup
        author {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        commentAuthorId
        likeUsers
        message
        isAuthorHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePostMutationVariables,
  APITypes.DeletePostMutation
>;
export const createComment = /* GraphQL */ `mutation CreateComment(
  $input: CreateCommentInput!
  $condition: ModelCommentConditionInput
) {
  createComment(input: $input, condition: $condition) {
    id
    post {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    commentPostId
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    commentAuthorId
    likeUsers
    message
    isAuthorHR
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCommentMutationVariables,
  APITypes.CreateCommentMutation
>;
export const updateComment = /* GraphQL */ `mutation UpdateComment(
  $input: UpdateCommentInput!
  $condition: ModelCommentConditionInput
) {
  updateComment(input: $input, condition: $condition) {
    id
    post {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    commentPostId
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    commentAuthorId
    likeUsers
    message
    isAuthorHR
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCommentMutationVariables,
  APITypes.UpdateCommentMutation
>;
export const deleteComment = /* GraphQL */ `mutation DeleteComment(
  $input: DeleteCommentInput!
  $condition: ModelCommentConditionInput
) {
  deleteComment(input: $input, condition: $condition) {
    id
    post {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    commentPostId
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    commentAuthorId
    likeUsers
    message
    isAuthorHR
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCommentMutationVariables,
  APITypes.DeleteCommentMutation
>;
export const createAnnouncement = /* GraphQL */ `mutation CreateAnnouncement(
  $input: CreateAnnouncementInput!
  $condition: ModelAnnouncementConditionInput
) {
  createAnnouncement(input: $input, condition: $condition) {
    id
    organizationGroup
    title
    message
    messageSource
    createdBy
    isActive
    isGlobal
    departmentIds
    createdAt
    deletedAt
    deletedBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAnnouncementMutationVariables,
  APITypes.CreateAnnouncementMutation
>;
export const updateAnnouncement = /* GraphQL */ `mutation UpdateAnnouncement(
  $input: UpdateAnnouncementInput!
  $condition: ModelAnnouncementConditionInput
) {
  updateAnnouncement(input: $input, condition: $condition) {
    id
    organizationGroup
    title
    message
    messageSource
    createdBy
    isActive
    isGlobal
    departmentIds
    createdAt
    deletedAt
    deletedBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAnnouncementMutationVariables,
  APITypes.UpdateAnnouncementMutation
>;
export const deleteAnnouncement = /* GraphQL */ `mutation DeleteAnnouncement(
  $input: DeleteAnnouncementInput!
  $condition: ModelAnnouncementConditionInput
) {
  deleteAnnouncement(input: $input, condition: $condition) {
    id
    organizationGroup
    title
    message
    messageSource
    createdBy
    isActive
    isGlobal
    departmentIds
    createdAt
    deletedAt
    deletedBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAnnouncementMutationVariables,
  APITypes.DeleteAnnouncementMutation
>;
export const createNote = /* GraphQL */ `mutation CreateNote(
  $input: CreateNoteInput!
  $condition: ModelNoteConditionInput
) {
  createNote(input: $input, condition: $condition) {
    id
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    noteAuthorId
    userToId
    message
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNoteMutationVariables,
  APITypes.CreateNoteMutation
>;
export const updateNote = /* GraphQL */ `mutation UpdateNote(
  $input: UpdateNoteInput!
  $condition: ModelNoteConditionInput
) {
  updateNote(input: $input, condition: $condition) {
    id
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    noteAuthorId
    userToId
    message
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNoteMutationVariables,
  APITypes.UpdateNoteMutation
>;
export const deleteNote = /* GraphQL */ `mutation DeleteNote(
  $input: DeleteNoteInput!
  $condition: ModelNoteConditionInput
) {
  deleteNote(input: $input, condition: $condition) {
    id
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    noteAuthorId
    userToId
    message
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNoteMutationVariables,
  APITypes.DeleteNoteMutation
>;
export const createNewEndorsement = /* GraphQL */ `mutation CreateNewEndorsement(
  $userID: String!
  $description: String!
  $endorsementId: String
) {
  createNewEndorsement(
    userID: $userID
    description: $description
    endorsementId: $endorsementId
  ) {
    id
    description
    status
    endorsementAssignedToId
    endorsementCreatedById
    previousEndorsementId
    previousEndorsement {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdBy {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNewEndorsementMutationVariables,
  APITypes.CreateNewEndorsementMutation
>;
export const joinCircle = /* GraphQL */ `mutation JoinCircle($circleId: String, $requestNotes: String) {
  joinCircle(circleId: $circleId, requestNotes: $requestNotes) {
    id
    organizationGroup
    role
    status
    requestStatus
    circleUserCircleId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circleUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    circleUserInviterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.JoinCircleMutationVariables,
  APITypes.JoinCircleMutation
>;
export const joinEvent = /* GraphQL */ `mutation JoinEvent($eventId: String, $requestNotes: String) {
  joinEvent(eventId: $eventId, requestNotes: $requestNotes) {
    id
    organizationGroup
    eventAttendeeId
    event {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    eventAttendeeUserId
    status
    requestStatus
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    eventAttendeeInviterId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.JoinEventMutationVariables,
  APITypes.JoinEventMutation
>;
export const adminAssignSkill = /* GraphQL */ `mutation AdminAssignSkill(
  $name: String!
  $description: String
  $completeAt: AWSDateTime!
  $userId: String!
  $skillIds: [String]
) {
  adminAssignSkill(
    name: $name
    description: $description
    completeAt: $completeAt
    userId: $userId
    skillIds: $skillIds
  ) {
    id
    organizationGroup
    skillId
    skill {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    completedAt
    verifiers {
      items {
        id
        skillUserId
        skillUser {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillId
        organizationGroup
        verifierId
        verifier {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        rating
        message
        isHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AdminAssignSkillMutationVariables,
  APITypes.AdminAssignSkillMutation
>;
export const assignSkills = /* GraphQL */ `mutation AssignSkills($skillTrackId: ID, $skillIds: [ID]) {
  assignSkills(skillTrackId: $skillTrackId, skillIds: $skillIds)
}
` as GeneratedMutation<
  APITypes.AssignSkillsMutationVariables,
  APITypes.AssignSkillsMutation
>;
export const inviteUserToCircle = /* GraphQL */ `mutation InviteUserToCircle(
  $circleId: ID!
  $targetUserIds: [ID!]!
  $notes: String
  $isHR: Boolean
) {
  inviteUserToCircle(
    circleId: $circleId
    targetUserIds: $targetUserIds
    notes: $notes
    isHR: $isHR
  ) {
    invitedCount
    totalRequested
    processed
    invitedUsers {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.InviteUserToCircleMutationVariables,
  APITypes.InviteUserToCircleMutation
>;
export const inviteUserToEvent = /* GraphQL */ `mutation InviteUserToEvent(
  $eventId: ID!
  $targetUserIds: [ID!]!
  $note: String
  $isHR: Boolean
) {
  inviteUserToEvent(
    eventId: $eventId
    targetUserIds: $targetUserIds
    note: $note
    isHR: $isHR
  ) {
    invitedCount
    totalRequested
    processed
    invitedUsers {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.InviteUserToEventMutationVariables,
  APITypes.InviteUserToEventMutation
>;
export const fanUser = /* GraphQL */ `mutation FanUser($userId: ID!, $fan: Boolean) {
  fanUser(userId: $userId, fan: $fan) {
    id
    description
    status
    approvedAt
    organizationGroup
    connectionUserFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userFromRequestType
    userFromRequestStatus
    connectionUserToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    userToRequestType
    userToRequestStatus
    introductionRequests {
      items {
        id
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToType
        introducer {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        introductionRequestUserFromId
        introductionRequestUserToId
        introducerId
        reason
        status
        message
        connectionId
        connection {
          id
          description
          status
          approvedAt
          organizationGroup
          connectionUserFromId
          userFromType
          userFromRequestType
          userFromRequestStatus
          connectionUserToId
          userToType
          userToRequestType
          userToRequestStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        introductionRequestIntroducerId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.FanUserMutationVariables,
  APITypes.FanUserMutation
>;
export const triggerCalculateCGPercentJob = /* GraphQL */ `mutation TriggerCalculateCGPercentJob {
  triggerCalculateCGPercentJob
}
` as GeneratedMutation<
  APITypes.TriggerCalculateCGPercentJobMutationVariables,
  APITypes.TriggerCalculateCGPercentJobMutation
>;
export const requestConnection = /* GraphQL */ `mutation RequestConnection(
  $userId: ID!
  $introducerId: ID
  $message: String
  $userFromType: UserType!
  $userToType: UserType!
  $secret: String
) {
  requestConnection(
    userId: $userId
    introducerId: $introducerId
    message: $message
    userFromType: $userFromType
    userToType: $userToType
    secret: $secret
  )
}
` as GeneratedMutation<
  APITypes.RequestConnectionMutationVariables,
  APITypes.RequestConnectionMutation
>;
export const responseIntroductionRequest = /* GraphQL */ `mutation ResponseIntroductionRequest(
  $requestIntroducerId: ID!
  $status: RequestIntroductionStatus!
  $reason: String
) {
  responseIntroductionRequest(
    requestIntroducerId: $requestIntroducerId
    status: $status
    reason: $reason
  ) {
    id
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToType
    introducer {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    introductionRequestUserFromId
    introductionRequestUserToId
    introducerId
    reason
    status
    message
    connectionId
    connection {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    introductionRequestIntroducerId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ResponseIntroductionRequestMutationVariables,
  APITypes.ResponseIntroductionRequestMutation
>;
export const updateFanConnection = /* GraphQL */ `mutation UpdateFanConnection($connectionId: ID!, $status: ConnectionStatus!) {
  updateFanConnection(connectionId: $connectionId, status: $status) {
    id
    description
    status
    approvedAt
    organizationGroup
    connectionUserFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userFromRequestType
    userFromRequestStatus
    connectionUserToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    userToRequestType
    userToRequestStatus
    introductionRequests {
      items {
        id
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToType
        introducer {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        introductionRequestUserFromId
        introductionRequestUserToId
        introducerId
        reason
        status
        message
        connectionId
        connection {
          id
          description
          status
          approvedAt
          organizationGroup
          connectionUserFromId
          userFromType
          userFromRequestType
          userFromRequestStatus
          connectionUserToId
          userToType
          userToRequestType
          userToRequestStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        introductionRequestIntroducerId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFanConnectionMutationVariables,
  APITypes.UpdateFanConnectionMutation
>;
export const recommendToUser = /* GraphQL */ `mutation RecommendToUser(
  $targetUser: String
  $purpose: VerifySkillPurpose!
  $type: RecommendationTypes!
  $message: String
  $typeID: String
  $typeIDs: [String]
  $userFromType: UserType
  $userToType: UserType
  $isFromHR: Boolean
  $verifierID: ID
  $targetUsers: [ID]
) {
  recommendToUser(
    targetUser: $targetUser
    purpose: $purpose
    type: $type
    message: $message
    typeID: $typeID
    typeIDs: $typeIDs
    userFromType: $userFromType
    userToType: $userToType
    isFromHR: $isFromHR
    verifierID: $verifierID
    targetUsers: $targetUsers
  ) {
    statusCode
    notificationID
    notificationIDs
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RecommendToUserMutationVariables,
  APITypes.RecommendToUserMutation
>;
export const requestChampions = /* GraphQL */ `mutation RequestChampions($targetUserId: ID, $requestMessage: String) {
  requestChampions(
    targetUserId: $targetUserId
    requestMessage: $requestMessage
  ) {
    id
    organizationGroup
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    status
    requestMessage
    approvedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RequestChampionsMutationVariables,
  APITypes.RequestChampionsMutation
>;
export const responseChampionRequest = /* GraphQL */ `mutation ResponseChampionRequest($championReqId: ID, $status: Status) {
  responseChampionRequest(championReqId: $championReqId, status: $status) {
    id
    organizationGroup
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    status
    requestMessage
    approvedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ResponseChampionRequestMutationVariables,
  APITypes.ResponseChampionRequestMutation
>;
export const myRewards = /* GraphQL */ `mutation MyRewards($purpose: MyRewardsPurpose!, $rewardID: String) {
  myRewards(purpose: $purpose, rewardID: $rewardID) {
    id
    organizationGroup
    title
    description
    isActive
    points
    pointsDiscount
    imageUrl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.MyRewardsMutationVariables,
  APITypes.MyRewardsMutation
>;
export const verifySkill = /* GraphQL */ `mutation VerifySkill(
  $purpose: VerifySkillPurpose!
  $targetUserID: String
  $targetObjectID: String!
  $withoutRequest: Boolean
  $rating: Int
  $message: String
  $isHR: Boolean
) {
  verifySkill(
    purpose: $purpose
    targetUserID: $targetUserID
    targetObjectID: $targetObjectID
    withoutRequest: $withoutRequest
    rating: $rating
    message: $message
    isHR: $isHR
  )
}
` as GeneratedMutation<
  APITypes.VerifySkillMutationVariables,
  APITypes.VerifySkillMutation
>;
export const manageConnection = /* GraphQL */ `mutation ManageConnection(
  $purpose: VerifySkillPurpose!
  $userType: RequestableUserTypes
  $userFromType: RequestableUserTypes
  $referenceID: String!
  $message: String
  $introducerId: ID
) {
  manageConnection(
    purpose: $purpose
    userType: $userType
    userFromType: $userFromType
    referenceID: $referenceID
    message: $message
    introducerId: $introducerId
  )
}
` as GeneratedMutation<
  APITypes.ManageConnectionMutationVariables,
  APITypes.ManageConnectionMutation
>;
export const importUser = /* GraphQL */ `mutation ImportUser($csvData: String) {
  importUser(csvData: $csvData)
}
` as GeneratedMutation<
  APITypes.ImportUserMutationVariables,
  APITypes.ImportUserMutation
>;
export const updateMembershipStatus = /* GraphQL */ `mutation UpdateMembershipStatus(
  $referenceType: CommonGroundReferenceType
  $referenceId: ID
  $status: Status
  $isHR: Boolean
) {
  updateMembershipStatus(
    referenceType: $referenceType
    referenceId: $referenceId
    status: $status
    isHR: $isHR
  )
}
` as GeneratedMutation<
  APITypes.UpdateMembershipStatusMutationVariables,
  APITypes.UpdateMembershipStatusMutation
>;
export const addNewCircle = /* GraphQL */ `mutation AddNewCircle(
  $name: String!
  $description: String
  $imageUrl: String
  $bannerImageUrl: String
  $privacy: CirclePrivacy!
  $interest: [String]
) {
  addNewCircle(
    name: $name
    description: $description
    imageUrl: $imageUrl
    bannerImageUrl: $bannerImageUrl
    privacy: $privacy
    interest: $interest
  ) {
    id
    name
    description
    imageUrl
    privacy
    event {
      items {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interest
    organizationGroup
    admins
    members {
      items {
        id
        organizationGroup
        role
        status
        requestStatus
        circleUserCircleId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        circleUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        circleUserInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    isManagedByHR
    creator
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddNewCircleMutationVariables,
  APITypes.AddNewCircleMutation
>;
export const addNewEvent = /* GraphQL */ `mutation AddNewEvent(
  $name: String!
  $description: String
  $imageUrl: String
  $bannerImageUrl: String
  $privacy: EnumPrivacy!
  $startTime: AWSDateTime!
  $endTime: AWSDateTime!
  $interests: [String]
  $isHidden: Boolean
  $circleEventId: ID
  $location: String
  $timezone: String
) {
  addNewEvent(
    name: $name
    description: $description
    imageUrl: $imageUrl
    bannerImageUrl: $bannerImageUrl
    privacy: $privacy
    startTime: $startTime
    endTime: $endTime
    interests: $interests
    isHidden: $isHidden
    circleEventId: $circleEventId
    location: $location
    timezone: $timezone
  ) {
    id
    organizationGroup
    name
    description
    imageUrl
    startTime
    endTime
    circleEventId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    attendee {
      items {
        id
        organizationGroup
        eventAttendeeId
        event {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        eventAttendeeUserId
        status
        requestStatus
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        eventAttendeeInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interests
    privacy
    admins
    timezone
    location
    createdAt
    isManagedByHR
    owner
    isHidden
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddNewEventMutationVariables,
  APITypes.AddNewEventMutation
>;
export const addUserGuidePoint = /* GraphQL */ `mutation AddUserGuidePoint($skillId: ID) {
  addUserGuidePoint(skillId: $skillId)
}
` as GeneratedMutation<
  APITypes.AddUserGuidePointMutationVariables,
  APITypes.AddUserGuidePointMutation
>;
export const removeSkill = /* GraphQL */ `mutation RemoveSkill($id: ID!, $context: EnumSkillContext, $isHR: Boolean) {
  removeSkill(id: $id, context: $context, isHR: $isHR)
}
` as GeneratedMutation<
  APITypes.RemoveSkillMutationVariables,
  APITypes.RemoveSkillMutation
>;
export const setUserHomepageConfig = /* GraphQL */ `mutation SetUserHomepageConfig(
  $config: String
  $disabledQuickQuestion: Boolean
) {
  setUserHomepageConfig(
    config: $config
    disabledQuickQuestion: $disabledQuickQuestion
  )
}
` as GeneratedMutation<
  APITypes.SetUserHomepageConfigMutationVariables,
  APITypes.SetUserHomepageConfigMutation
>;
export const assignNewAdminToContextBulk = /* GraphQL */ `mutation AssignNewAdminToContextBulk($data: [AssignNewAdminToContextInput]!) {
  assignNewAdminToContextBulk(data: $data)
}
` as GeneratedMutation<
  APITypes.AssignNewAdminToContextBulkMutationVariables,
  APITypes.AssignNewAdminToContextBulkMutation
>;
export const deleteUserByAdmin = /* GraphQL */ `mutation DeleteUserByAdmin($targetUserId: ID!) {
  deleteUserByAdmin(targetUserId: $targetUserId) {
    status
    circlesOwned {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    eventsOwned {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserByAdminMutationVariables,
  APITypes.DeleteUserByAdminMutation
>;
export const deleteCircleEventPost = /* GraphQL */ `mutation DeleteCircleEventPost($id: ID!, $type: AdminManageContentTypes) {
  deleteCircleEventPost(id: $id, type: $type)
}
` as GeneratedMutation<
  APITypes.DeleteCircleEventPostMutationVariables,
  APITypes.DeleteCircleEventPostMutation
>;
export const recordVisitByContext = /* GraphQL */ `mutation RecordVisitByContext(
  $contextId: ID
  $contextType: AdminManageContentTypes
) {
  recordVisitByContext(contextId: $contextId, contextType: $contextType)
}
` as GeneratedMutation<
  APITypes.RecordVisitByContextMutationVariables,
  APITypes.RecordVisitByContextMutation
>;
export const manageInterest = /* GraphQL */ `mutation ManageInterest(
  $categoryId: String
  $categoryName: String
  $isDeleted: Boolean
  $interests: [InterestInput]
) {
  manageInterest(
    categoryId: $categoryId
    categoryName: $categoryName
    isDeleted: $isDeleted
    interests: $interests
  ) {
    tagCategory {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    interests {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ManageInterestMutationVariables,
  APITypes.ManageInterestMutation
>;
export const sendSlackMessage = /* GraphQL */ `mutation SendSlackMessage(
  $title: String
  $description: String
  $type: SlackMessageType
  $attachmentUrls: [String]
  $isAnonymous: Boolean
) {
  sendSlackMessage(
    title: $title
    description: $description
    type: $type
    attachmentUrls: $attachmentUrls
    isAnonymous: $isAnonymous
  )
}
` as GeneratedMutation<
  APITypes.SendSlackMessageMutationVariables,
  APITypes.SendSlackMessageMutation
>;
